// extracted by mini-css-extract-plugin
export default {"menuItem":"SidebarItem_menuItem__kNQlR","active":"SidebarItem_active__l87dh"};